export default __webpack_public_path__ + "static/media/hero-screenshot-1.6071e32c.png";